import { FieldType } from "./Field";

export interface FieldResponse {
    type: FieldType;
    label: string;
    value: string;
    roster: boolean;
    description?: string;
    options?: any[];
    url?: string;
    unit?: string;
    summation?: boolean;
    pickupLocation?: { id: string; name?: string; arrivalOffset?: number };
    optInByDefault?: boolean;
}

export interface AddonFieldResponse extends FieldResponse {
    sku: string;
    lineItemTemplate: { id: ID; code: string };
    /** Back office only: overrides the add-on's overridable limits for the whole reservation. */
    _overrideRestrictions?: boolean;
}

export enum FormResponseFields {
    EMAIL = "Email",
    PHONE = "Phone",
    NAME = "Name",
}
